"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Reason = exports.NoContent = void 0;
var NoContent_1 = require("./src/components/NoContent");
Object.defineProperty(exports, "NoContent", { enumerable: true, get: function () { return NoContent_1.NoContent; } });
Object.defineProperty(exports, "Reason", { enumerable: true, get: function () { return NoContent_1.Reason; } });
//# sourceMappingURL=index.js.map